import { apiClient } from "../client/ApiClient";
import { Address } from "../types/Address";

const findAddressSummaryByIcp = async (icpNumber: string): Promise<Address> => {
  return await apiClient
    .get<Address>("address/icp/" + icpNumber)
    .then((response) => response.data);
};

export default findAddressSummaryByIcp;
